import './data-table.css';
import React, { useState } from 'react';
import RowHeader from './components/row-header/row-header';
import { renderCell } from './operations/render-cell';

export interface TableDataDatamodel {
  lazyLoading: {
    columnNumber: number;
    rowsNumber: number;
  };
  isLoading: boolean;
  table: Table;
  onRowSelected?: (index: number) => void;
  isAddActive: boolean;
  autoAddIndex: boolean;
}

export enum CelType {
  REGULAR,
  GREEN_BG,
  RED_BG,
  YELLOW_BG,
  CHECK_BOX,
  APPROVE_ICON,
  TEXT_COLOR_GREEN,
  TEXT_COLOR_RED,
  TEXT_COLOR_YELLOW,
  EDIT_TEXT_GRADE,
  CALENDAR,
  BUTTON,
  INPUT,
}

export interface Cell {
  content: string;
  checkBoxDefaultValue?: boolean;
  type: CelType;
  style?: React.CSSProperties;
  onClick?: () => void;
  input?: {
    onChange: (value: string) => void;
    onCheckBoxChange?: (isActive: boolean) => void;
  };
}

export interface Row {
  cells: Cell[];
  nestedTable?: Table;
  id?: number;
}
export interface AddRow {
  inputRow: Row;
  onSubmit: () => void;
  isInputActive: boolean;
  isApproveLoading: boolean;
}
export interface Table {
  rowHeader?: Row;
  rows: Row[];
  addRow?: AddRow;
}

const DataTable: React.FC<TableDataDatamodel> = ({
  lazyLoading,
  isLoading,
  table,
  onRowSelected,
  isAddActive,
  autoAddIndex = false,
}) => {
  const [value, setValue] = useState<Date | null>(null);

  const gridTemplateColumns = isLoading
    ? `repeat(${lazyLoading.columnNumber}, auto)`
    : `repeat(${table.rowHeader ? table.rowHeader.cells.length : (table.rows?.[0]?.cells.length ?? 0)}, auto)`;

  return (
    <div style={{ justifyContent: 'stretch' }}>
      <div
        className="table-data-root"
        style={{
          gridTemplateColumns,
          border: '1px solid #F7F7F7',
          borderRadius: '8px',
        }}
      >
        {table && table.rowHeader && <RowHeader rowHeader={table.rowHeader} />}

        <div
          style={{
            display: 'contents',
            gridTemplateColumns,
            gap: isLoading ? 20 : 0,
          }}
        >
          {isLoading &&
            [...Array(lazyLoading.rowsNumber)].map((row, rowIndex) => (
              <div className={'grid-row-container'}>
                {[...Array(lazyLoading.columnNumber)].map((item, colIndex) => (
                  <div
                    className="shimmer grid-cell-loading"
                    style={{ height: '20px', width: '100%' }}
                  ></div>
                ))}
              </div>
            ))}
        </div>

        {!isLoading &&
          table &&
          table.rows.map((row, rowIndex) => (
            <div
              className={'grid-row-container'}
              onClick={() => {
                if (onRowSelected) {
                  onRowSelected(rowIndex, row.id);
                }
              }}
            >
              {row.cells.map((item, colIndex) => {
                const borderStyle = {
                  borderBottomRightRadius:
                    rowIndex === table.rows.length - 1 && colIndex === 0
                      ? '8px'
                      : '',
                  borderBottomLeftRadius:
                    rowIndex === table.rows.length - 1 &&
                    colIndex === row.cells.length - 1
                      ? '8px'
                      : '',
                };

                return (
                  <>
                    {item.style ? (
                      <div
                        className={'grid-row-cell-custom'}
                        style={{ ...item.style }}
                      >
                        {renderCell(item)}
                      </div>
                    ) : (
                      <div
                        key={`${rowIndex}-${colIndex}`}
                        style={{ ...borderStyle }}
                        className={
                          rowIndex === table.rows.length - 1
                            ? 'grid-item-last'
                            : 'grid-item'
                        }
                      >
                        <div>{renderCell(item)}</div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          ))}

        {isAddActive && (
          <div className={'grid-row-container'}>
            {autoAddIndex && (
              <div className={'grid-item'}>
                {renderCell({
                  content: (table.rows.length + 1).toString(),
                  type: CelType.REGULAR,
                })}
              </div>
            )}
            {table?.addRow?.inputRow.cells.map((item, b) => (
              <div className={'grid-item'} style={{ ...item.style }}>
                {renderCell(item)}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DataTable;
